import { Link } from "react-router-dom";
import BrushMark from "@/components/BrushMark";
import { assetUrl } from "@/lib/assets";

export default function Footer() {
  return (
    <footer className="mt-32 hairline-top" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <BrushMark size={84} asLink={false} />
            <p className="mt-8 max-w-md text-graphite/80 leading-relaxed">
              Carlton Elleker Chase is a modern London law firm advising corporates, founders, funds
              and private clients across six core practices.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs text-graphite/50 mb-3">Office</p>
            <p className="leading-relaxed">
              1 Quality Court<br />
              Chancery Lane<br />
              London WC2A 1HR
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs text-graphite/50 mb-3">Contact</p>
            <p className="leading-relaxed">
              <a href="tel:+442031051755" className="hover:text-[#1E3668]">+44 (0) 203 105 1755</a><br />
              <a href="mailto:info@ceclegal.co.uk" className="hover:text-[#1E3668]">info@ceclegal.co.uk</a>
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs text-graphite/50 mb-3">Index</p>
            <ul className="space-y-2">
              <li><Link to="/expertise" className="hover:text-[#1E3668]">Services</Link></li>
              <li><Link to="/people" className="hover:text-[#1E3668]">People</Link></li>
              <li><Link to="/insights" className="hover:text-[#1E3668]">Insights</Link></li>
              <li><Link to="/about" className="hover:text-[#1E3668]">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#1E3668]">Contact</Link></li>
              <li><Link to="/admin/login" className="text-graphite/50 hover:text-[#1E3668]" data-testid="admin-login-link">Admin</Link></li>
            </ul>
          </div>
        </div>

        {/* Regulatory line */}
        <div className="mt-16 pt-8 hairline-top">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
            <div className="md:col-span-9">
              <p className="text-sm text-graphite/70 max-w-3xl leading-relaxed" data-testid="footer-regulatory">
                Carlton Elleker Chase is a trading name of Carlton Elleker Chase Limited which is
                authorised by the Solicitors Regulation Authority, SRA No: 8006648.
              </p>
              <p className="mt-3 text-sm text-graphite/70" data-testid="footer-policies">
                <Link to="/privacy" className="hover:text-[#1E3668]">Privacy and Cookie Policy</Link>
                <span className="mx-2 text-graphite/30">|</span>
                <Link to="/terms" className="hover:text-[#1E3668]">Terms and Conditions</Link>
                <span className="mx-2 text-graphite/30">|</span>
                <Link to="/complaint" className="hover:text-[#1E3668]">Complaint Procedure</Link>
              </p>
              <p className="mt-6 text-xs text-graphite/55">
                © {new Date().getFullYear()} Carlton Elleker Chase Limited. All rights reserved.
              </p>
            </div>
            <div className="md:col-span-3 md:justify-self-end">
              <a
                href="https://www.sra.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block opacity-90 hover:opacity-100 transition-opacity"
                aria-label="Regulated by Solicitors Regulation Authority"
                data-testid="sra-badge-link"
              >
                <img
                  src={assetUrl("/brand/sra-badge.jpg")}
                  alt="Regulated by Solicitors Regulation Authority"
                  className="w-[140px] md:w-[160px] h-auto"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
